export default "__VITE_ASSET__I6tQG6gd__"